import React from "react";
import queenscourt from "../assets/Images/Projects/queenscourt.jpg"
import marblehouse from "../assets/Images/Projects/marblehouse/newmarblehillhouse.jpg"
import portlandplace from "../assets/Images/Projects/portlandplace/devonshiresquare.jpg"
import wimpole from "../assets/Images/Projects/wimpole.jpg"
import wrothampark from "../assets/Images/Projects/wrothampark.jpg"
import london from "../assets/Images/Projects/london-1.jpg"
import chancellors from "../assets/Images/Projects/cs-2.jpg"
import Essendon from "../assets/Images/Projects/ecc.jpg"
import "../assets/css/App.css";
import "../assets/css/index.css";
import "../assets/css/Section.css";
import "../assets/css/ProjectsBlock.css";
import { Link } from "gatsby";
import { Row, Col } from "react-bootstrap";

export const ProjectsBlock = () => {
  return (
    <>
    <Row>
      <Col sm className="home-button">
        <Link to="/queenscourt-baywater-case-study/">
          <img
            alt="Image of boiler"
            class="pb-4 mx-auto d-block project-icon"
            src={queenscourt}
          />
          <h3 class="heading-color text-center">Queenscourt, Baywater</h3>
          <p class="text-center normal-text-colour">
          BBIS Heating renewed and rationalised the boiler plant at Queens Court, Bayswater - a 337-flat estate in West London - delivering a centralised, efficient heating and hot water system.
          </p>
        </Link>
      </Col>
      <Col sm className="home-button">
        <Link to="/commercial-plant-room-installation-marble-house/">
          <img
            alt="Image of pipes"
            class="pb-4 mx-auto d-block project-icon"
            src={marblehouse}
          />
          <h3 class="heading-color text-center">Marble House</h3>
          <p class="text-center normal-text-colour">
            We modernised a 1970s boiler room with new high-efficiency condensing boilers, stainless steel flues, upgraded pipework and controls, delivering a reliable and efficient heating system.
          </p>
        </Link>
      </Col>
      <Col sm className="home-button">
        <Link
          to="/commercial-plant-room-installation-portland-place/"
          className="project-icon"
        >
          <img
            alt="Image of spanner"
            class="pb-4 mx-auto d-block project-icon"
            src={portlandplace}
          />
          <h3 class="heading-color text-center">Portland Place</h3>
          <p class="text-center normal-text-colour">
            We transformed an outdated boiler room into a modern, energy-efficient plant with three A-rated condensing boilers, advanced pumps, and BMS controls - improving efficiency, reducing energy bills, and reclaiming valuable space for residents.
          </p>
        </Link>
      </Col>
    </Row>
    <Row>
  <Col sm className="home-button">
    <Link to="/commercial-plant-room-installation-wimpole-street/">
      <img
        alt="Wimpole Street boiler room upgrade"
        class="pb-4 mx-auto d-block project-icon"
        src={wimpole}
      />
      <h3 class="heading-color text-center">Wimpole Street</h3>
      <p class="text-center normal-text-colour">
        BBIS Heating replaced an outdated 1980s boiler room with a compact, high-performance system featuring three 115kW Remeha boilers, twin calorifiers, and a bespoke TREND BMS control panel, freeing up space for new reception and washroom facilities.
      </p>
    </Link>
  </Col>
  <Col sm className="home-button">
    <Link to="/projects/#wrothampark">
      <img
        alt="Wrotham Park condensing boiler installation"
        class="pb-4 mx-auto d-block project-icon"
        src={wrothampark}
      />
      <h3 class="heading-color text-center">Wrotham Park</h3>
      <p class="text-center normal-text-colour">
        BBIS Heating decommissioned and removed the outdated boiler plant and installed three new condensing boilers with fully modulating burners, stainless steel calorifiers, modern automatic controls, and full pipework insulation.
      </p>
    </Link>
  </Col>
  <Col sm className="home-button">
    <Link to="/projects/#londonW1" className="project-icon">
      <img
        alt="London W1 sealed system conversion"
        class="pb-4 mx-auto d-block project-icon"
        src={london}
      />
      <h3 class="heading-color text-center">London W1</h3>
      <p class="text-center normal-text-colour">
        We replaced ageing boilers with high-efficiency units, installed custom pipework and controls and completed a sealed system conversion, resulting in quieter, more efficient heating with improved flow throughout the building.
      </p>
    </Link>
  </Col>
</Row>

<Row>
  <Col sm className="home-button">
    <Link to="/projects/#essendoncountryclub">
      <img
        alt="Essendon Country Club underfloor heating installation"
        class="pb-4 mx-auto d-block project-icon"
        src={Essendon}
      />
      <h3 class="heading-color text-center">Essendon Country Club</h3>
      <p class="text-center normal-text-colour">
        BBIS Heating installed underfloor heating at Essendon Country Club’s clubhouse extension, using 700 metres of pipe, a manifold system, and remote thermostat control to maximise seating and minimise visual impact.
      </p>
    </Link>
  </Col>
    <Col sm className="home-button">
    <Link to="/projects/#chancellorsschool">
      <img
        alt="Chancellor’s School boiler room servicing"
        class="pb-4 mx-auto d-block project-icon"
        src={chancellors}
      />
      <h3 class="heading-color text-center">Chancellor’s School</h3>
      <p class="text-center normal-text-colour">
        BBIS Heating carried out a comprehensive service across three boiler rooms, including gas meter and pipework testing, while maintaining radiant heaters, water heaters, pumps, and pressurisation units for full operational safety.
      </p>
    </Link>
  </Col>
</Row>

    </>
    
    
  );
};
